import { create } from 'zustand';

export type Locale = 'es' | 'en' | 'zh';

interface LocaleState {
  locale: Locale;
  setLocale: (locale: Locale) => void;
}

const LOCALE_KEY = 'agrovid_locale';

function readLocale(): Locale {
  try {
    const v = localStorage.getItem(LOCALE_KEY);
    if (v === 'en') return 'en';
    if (v === 'zh') return 'zh';
    return 'es';
  } catch {
    return 'es';
  }
}

export const useLocaleStore = create<LocaleState>((set) => ({
  locale: readLocale(),
  setLocale: (locale: Locale) => {
    try { localStorage.setItem(LOCALE_KEY, locale); } catch { /* ignore */ }
    set({ locale });
  },
}));
